import type { Block } from '@vedalib/editor/lib/block'
import { DeviceMode } from '@vedalib/editor/lib/project'
import * as R from 'ramda'

import { notify } from 'components/uiKit/Notification'
import { NotificationType } from 'components/uiKit/Notification/types'
import { setProjectNavigation, updateBlock } from 'services/Store/Project/actions'
import { rejectNode } from 'services/Store/Project/mutators/node'
import { getBlock, getDeviceMode, getSelectedNodeIds } from 'services/Store/Project/selectors'
import store from 'services/Store/store'
import { t } from 'services/Translation'

export const onDelete = (event?: KeyboardEvent) => {
  const state = store.getState().project
  const dispatch = store.dispatch
  const block = getBlock(state)
  const selectedNodes = getSelectedNodeIds(state)
  const isDesktop = getDeviceMode(state) === DeviceMode.desktop

  if (block && selectedNodes.length) {
    if (!isDesktop) {
      return notify({
        type: NotificationType.info,
        message: t('editorV2.notifyStructureChangesRestricted'),
      })
    }
    event?.preventDefault()
    const cbs = selectedNodes.map((id) => rejectNode(id)) as [(block: Block) => Block]
    dispatch(updateBlock({ id: block.uuid, value: R.compose(...cbs)(block) }))
    dispatch(setProjectNavigation({ nodeIds: [] }))
  }
}
